//import React from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
//import aboutImg from '../assets2/images/second-img.jpg';
//
//const About = () => (
//  <section className="about__v4 section" id="about">
//    <Container>
//      <Row className="align-items-center">
//        <Col
//          md={6}
//          className="order-md-2 d-flex align-items-center justify-content-center"
//        >
//          <Row className="justify-content-end w-100">
//            <Col md={11} className="mb-4 mb-md-0">
//              <span className="subtitle">About us</span>
//              <h2 className="mb-4">
//               Empowering Indian Businesses with Smarter Billing Solutions
//              </h2>
//              <div>
//                <p>
//         At HamaraBillBook, we’re on a mission to simplify business operations 
//		 for small and medium enterprises across India. Designed with the needs of Indian 
//		 entrepreneurs in mind, our GST-compliant billing software helps you manage 
//		 invoicing, inventory, payments, and compliance -all from one easy-to-use platform.</p>
//                <p>
//                Whether you run a shop, wholesale business, or service company, HamaraBillBook gives you 
//				the tools to go digital, stay organized, and grow with confidence.
//                </p>
//              </div>
//              <h4 className="small fw-bold mt-4 mb-3">Why Businesses Trust Us:</h4>
//              <ul className="d-flex flex-row flex-wrap list-unstyled gap-3 features">
//                <li className="d-flex align-items-center gap-2">
//                  <span className="icon rounded-circle text-center">
//                    <i className="bi bi-check"></i>
//                  </span>
//                  <span className="text">100% GST Compliant</span>
//                </li>
//                <li className="d-flex align-items-center gap-2">
//                  <span className="icon rounded-circle text-center">
//                    <i className="bi bi-check"></i>
//                  </span>
//                  <span className="text"> Easy e-Invoicing & e-Way Billing</span>
//                </li>
//                <li className="d-flex align-items-center gap-2">
//                  <span className="icon rounded-circle text-center">
//                    <i className="bi bi-check"></i>
//                  </span>
//                  <span className="text">Works in English, Hindi & Regional Languages</span>
//                </li>
//                <li className="d-flex align-items-center gap-2">
//                  <span className="icon rounded-circle text-center">
//                    <i className="bi bi-check"></i>
//                  </span>
//                  <span className="text"> Fast, Secure & Made for Bharat</span>
//                </li>
//                {/*<li className="d-flex align-items-center gap-2">
//                  <span className="icon rounded-circle text-center">
//                    <i className="bi bi-check"></i>
//                  </span>
//                  <span className="text">Empowerment</span>
//                </li>*/}
//              </ul>
//            </Col>
//          </Row>
//        </Col>
//
//        <Col md={6} className="d-flex justify-content-center">
//          <div className="img-wrap position-relative w-100">
//            {/*<img
//              className="img-fluid rounded-4 w-100"
//              src={aboutImg}
//              alt="About"
//              style={{ objectFit: 'cover', maxHeight: '100%', maxWidth: '100%' }}
//            />*/}
//			   <img
//			  className="img-main img-fluid rounded-4"
//			  src={aboutImg}
//			  alt="Hero"
//			  style={{
//				width: '100%',
//				maxWidth: '500px', // limits image width on large screens
//				height: 'auto',
//				display: 'block',
//				margin: '0 auto'
//			  }}
//			/>
//          </div>
//        </Col>
//      </Row>
//    </Container>
//  </section>
//);
//
//export default About;



import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import aboutImg from '../assets2/images/invoice_woman.png';
import './frontend.css';

const About = () => (
  <section className="about__v4" id="about">
    <Container fluid className="p-0">
      <Row className="align-items-center mx-0">
        <Col
          md={6}
          className="order-md-2 px-0 d-flex align-items-center justify-content-center"
        >
          <Row className="justify-content-end w-100 mx-0">
            <Col md={11} className="mb-4 mb-md-0 px-0">
              <span className="subtitle">About us</span>
              <h2 className="mb-4">
                Empowering Indian Businesses with Smarter Billing Solutions
              </h2>
              <div>
                <p>
                  At HamaraBillBook, we’re on a mission to simplify business operations
                  for small and medium enterprises across India. Designed with the needs of Indian
                  entrepreneurs in mind, our GST-compliant billing software helps you manage
                  invoicing, inventory, payments, and compliance - all from one easy-to-use platform.
                </p>
                <p>
                  Whether you run a shop, wholesale business, or service company, HamaraBillBook gives you
                  the tools to go digital, stay organized, and grow with confidence.
                </p>
              </div>
              <h4 className="small fw-bold mt-4 mb-3">Why Businesses Trust Us:</h4>
              <ul className="d-flex flex-row flex-wrap list-unstyled gap-3 features">
                {[
                  '100% GST Compliant',
                  'Easy e-Invoicing & e-Way Billing',
                  'Works in English, Hindi & Regional Languages',
                  'Fast, Secure & Made for Bharat',
                ].map((item, index) => (
                  <li key={index} className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check"></i>
                    </span>
                    <span className="text">{item}</span>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Col>

        <Col md={6} className="d-flex justify-content-center">
          <div className="img-wrap position-relative w-100">
            <img
              className="img-main img-fluid rounded-4"
              src={aboutImg}
              alt="Hero"
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                display: 'block',
                margin: '0 auto'
              }}
            />
          </div>
        </Col>
      </Row>

      {/* Legal Links Section from Request */}
      <div className="legal-container mt-5 text-center">
        <div className="d-flex justify-content-center align-items-center gap-3">
          <Link to="/privacy" className="legal-link text-decoration-none" style={{ color: '#0dcaf0' }}>Privacy Policy</Link>
          <div className="legal-divider" style={{ width: '1px', height: '20px', backgroundColor: '#ccc' }}></div>
          <Link to="/terms" className="legal-link text-decoration-none" style={{ color: '#0dcaf0' }}>Terms of Service</Link>
        </div>
      </div>
    </Container>
  </section >
);

export default About;
